module.exports = __webpack_public_path__ + "static/maunish_patel-d3d4f7a9a64c1f9d2466dc30a8f0ef47.jpg";